import "./icon.custom.objectSection.css"
import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"

export type IconCustomObjectSectionProps = ComponentProps<"svg">
function IconCustomObjectSection(props: IconCustomObjectSectionProps) {
  const { className, viewBox = "0 0 16 16", fill = "none", ...svgProps } = props

  return (
    <svg
      className={cn("objectSection__svg", className)}
      viewBox={viewBox}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        className="objectSection__svg_main"
        d="M0 3.81649C0 3.51057 0.130767 3.21925 0.359344 3.01593L3.03792 0.633387C3.44395 0.272228 4.05605 0.272228 4.46208 0.633387L7.14066 3.01593C7.36923 3.21925 7.5 3.51057 7.5 3.81649V6.42857C7.5 7.0203 7.0203 7.5 6.42857 7.5H1.07143C0.479695 7.5 0 7.0203 0 6.42857V3.81649Z"
      />
      <path
        className="objectSection__svg_main"
        d="M8.5 3.81649C8.5 3.51057 8.63077 3.21925 8.85934 3.01593L11.5379 0.633387C11.9439 0.272228 12.5561 0.272228 12.9621 0.633387L15.6407 3.01593C15.8692 3.21925 16 3.51057 16 3.81649V6.42857C16 7.0203 15.5203 7.5 14.9286 7.5H9.57143C8.97969 7.5 8.5 7.0203 8.5 6.42857V3.81649Z"
      />
      <path
        className="objectSection__svg_main"
        d="M0 11.6683C0 11.3624 0.130767 11.071 0.359344 10.8677L3.03792 8.48516C3.44395 8.124 4.05605 8.124 4.46208 8.48516L7.14066 10.8677C7.36923 11.071 7.5 11.3624 7.5 11.6683V14.2803C7.5 14.8721 7.0203 15.3518 6.42857 15.3518H1.07143C0.479695 15.3518 0 14.8721 0 14.2803V11.6683Z"
      />
      <path
        className="objectSection__svg_main"
        d="M8.5 11.6683C8.5 11.3624 8.63077 11.071 8.85934 10.8677L11.5379 8.48516C11.9439 8.124 12.5561 8.124 12.9621 8.48516L15.6407 10.8677C15.8692 11.071 16 11.3624 16 11.6683V14.2803C16 14.8721 15.5203 15.3518 14.9286 15.3518H9.57143C8.97969 15.3518 8.5 14.8721 8.5 14.2803V11.6683Z"
      />
    </svg>
  )
}

export default IconCustomObjectSection
